import React from 'react';

export function SuccessCheckFilled () {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#4FADA6" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4495 8.21922C17.1455 7.91524 16.6527 7.91524 16.3487 8.21922L13.6706 10.8973L10.4422 14.1258L7.65007 11.3337C7.34629 11.0299 6.85377 11.0299 6.54999 11.3337C6.24623 11.6374 6.24621 12.1299 6.54994 12.4337L10.0383 15.9227C10.2613 16.1458 10.623 16.1458 10.8461 15.9227L17.4495 9.32003C17.7535 9.01606 17.7535 8.5232 17.4495 8.21922Z" fill="white" />
    </svg>

  );
}
